export interface ISolarSearchAccount {
  fullName: string;
  address: string;
  emailAddress: string;
  phoneNumber: string;
  customerNumber: string;
  partnerNumber: string;
  leadNumber: string;
  isActive: boolean;
  excelergyLdcAccountNumber: string;
}

export class SolarSearchAccount implements ISolarSearchAccount {
  fullName: string;
  address: string;
  emailAddress: string;
  phoneNumber: string;
  customerNumber: string;
  partnerNumber: string;
  leadNumber: string;
  isActive: boolean;
  excelergyLdcAccountNumber: string;
}
